import {useCallback, useState} from 'react';

export const useForceUpdate = () => {
  const [, setState] = useState(1);
  return useCallback(() => setState(s => s + 1), []);
};
